import { useContext } from 'react';
import { PageContext } from './contexts';

export default function usePage() {
  const { language } = useContext(PageContext);
  return { language };
}
